import { Button, Tooltip, withStyles } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import theme from './theme';
import { useState } from 'react';

const {
  colors: { background, numberColor },
} = theme;

const LightTooltip = withStyles(({ shadows, fontSizes }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    fontWeight: 600,
    
    
    
    
  },
}))(Tooltip);


const Info = ({ title, data = {}, views = {}, type, toolTipText }) => {
  const { classes, theme: { fontSizes, spacing } } = useStyles(styles);
  const { push } = useHistory();

  const goToSchoolFormation = (route) => {
    push({
      pathname: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
      state: { route: route },
    });
  };

  const goToSchoolPartner = () => {
    push(ROUTES_PATH.SCHOOL_PARTNERS);
  };

  const goToAffiliation = () => {
    push(ROUTES_PATH.SCHOOL_AFFILIATION);
  };

  const goToClasses = () => {
    push(ROUTES_PATH.SCHOOL_CLASSES);
  };
  const goToVitrine = () => {
    push(ROUTES_PATH.EDIT_SCHOOL_VITRINE);
  };

  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <FormattedMessage id={title} />
        <LightTooltip open={showTooltip}
          onOpen={() => setShowTooltip(true)}
          onClose={() => setShowTooltip(false)} placement='top-start' title={toolTipText}>
          <div onClick={() => setShowTooltip(!showTooltip)} style={{ borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '30px', display: 'flex', justifyContent: 'center', height: '30px', alignItems: 'center', cursor: 'pointer', color: '#5A6DA1', position: 'relative', top: '-7px', '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'}, fontFamily: 'Montserrat', fontWeight: 600 }}>
            ?
          </div>
        </LightTooltip>
      </div>
      {type === 'student' && (
        <>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.etudiants.entreprise" />
            </div>
            <Button className={classes.doubleNombre} onClick={goToClasses}>
              {data?.workStudyStudents} / {data?.totalStudents}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.etudiants.totalEtudiant" />
            </div>
            <Button className={classes.nombre} onClick={goToClasses}>
              {data?.totalStudents}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.etudiants.envoye" />
            </div>
            <Button className={classes.nombre} onClick={goToClasses}>
              {data?.contractsToSend}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.etudiants.attente" />
            </div>
            <Button className={classes.nombre} onClick={goToClasses}>
              {data?.contractsToSign}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.etudiants.attente2" />
            </div>
            <Button className={classes.nombre} onClick={goToClasses}>
              {data?.contractsToSign}
            </Button>
          </div>
        </>
      )}
      {type === 'affiliate' && (
        <>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.affiliations.attente" />
            </div>
            <Button className={classes.nombre} onClick={goToAffiliation}>
              {data?.pendingAffiliates}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.affiliations.complete" />
            </div>
            <Button className={classes.nombre} onClick={goToAffiliation}>
              {data?.completedAffiliates}
            </Button>
          </div>
        </>
      )}
      {type === 'course' && (
        <>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.formationsCandidats.ouverte" />
            </div>
            <Button className={classes.nombre} onClick={() => goToSchoolFormation('formation')}>
              {data?.totalTrainings - data?.closedTrainings}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.formationsCandidats.ferme" />
            </div>
            <Button className={classes.nombre} onClick={() => goToSchoolFormation('formation')}>
              {data?.closedTrainings}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.formationsCandidats.candidat" />
            </div>
            <Button className={classes.nombre} onClick={() => goToSchoolFormation('candidats')}>
              {data?.totalApplications}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="Vues de ma vitrine" />
            </div>
            <Button className={classes.nombre} onClick={() => goToVitrine()}>
              {views?.schoolViews}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="Vues de mes formations" />
            </div>
            <Button className={classes.nombre} onClick={() => goToSchoolFormation('formation')}>
              {views?.trainingsViews}
            </Button>
          </div>
        </>
      )}
      {type === 'partner' && (
        <>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.partenaires.nombre" />
            </div>
            <Button className={classes.nombre} onClick={goToSchoolPartner}>
              {data?.totalPartners}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.partenaires.emploi" />
            </div>
            <Button className={classes.nombre} onClick={goToSchoolPartner}>
              {data?.totalJobs}
            </Button>
          </div>
          <div className={classes.notify}>
            <div className={classes.subTitle}>
              <FormattedMessage id="school.dashboard.partenaires.student" />
            </div>
            <Button className={classes.nombre} onClick={goToSchoolPartner}>
              {data?.studentAtPartners}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  title: {
    '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'},
    fontWeight: 600,
    color: '#152652',
    fontFamily: 'Montserrat',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'top',
  },
  notify: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: spacing(1),
    alignItems: 'end',
  },
  subTitle: {
    color: '#5D75A8',
    fontSizes: fontSizes(16),
    
    
    
    
  },
  doubleNombre: {
    height: '60%',
    padding: 0,
    minWidth: 0,
    fontWeight: 400,
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    margin: spacing(0, 1.25, 0, 0),
    '@media (max-width:1440px)': { margin: spacing(0), width: '15%' },
    
    
    
    
    border: 'none',
    '& > *': {
      color: numberColor,
    },
    '&:hover': {
      border: 'none',
      backgroundColor: 'white',
      '& > *': {
        fontWeight: 600,
      },
    },
  },
  nombre: {
    height: '60%',
    padding: 0,
    minWidth: 0,
    fontWeight: 400,
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    margin: spacing(0, 1.25, 0, 0),
    
    
    
    
    border: 'none',
    '& > *': {
      color: numberColor,
    },
    '&:hover': {
      border: 'none',
      backgroundColor: 'white',
      '& > *': {
        fontWeight: 600,
      },
    },
  },
});


Info.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  data: PropTypes.object,
};

export default Info;
